import API from "@/services/api/api.service";
import { Consent, ConsentVersion } from "@/utils/models/consent.model";
import dayjs from "dayjs";
import { RouteLocationNormalized } from "vue-router";

export const consentVersionResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        const res = await API.getConsentVersion({consent_id: to.params.id as string, version_id: to.params.version_id as string});
        to.meta.consent_version = res.data.data;
    } catch (error) {
        console.error('CONSENT_VERSION_RESOLVER_ERROR');
        return { name: 'Consents' };
    }
}